"use strict";

import axios from "axios";
import store from '../store/index.js';
import { getToken } from '@/utils/auth'
import {Notification, MessageBox, Message} from 'element-ui'
import errorCode from '@/utils/errorCode'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const _axios = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 600 * 1000, // 请求超时
    withCredentials: true, // Check cross-site Access-Control
});

// 请求拦截器
_axios.interceptors.request.use(
    function (config) {
        if (getToken()) {
            config.headers['Authorization'] = 'Bearer ' + getToken()
        }
        // get请求映射params参数
        if (config.method === 'get' && config.params) {
            let url = config.url + '?';
            for (const propName of Object.keys(config.params)) {
                const value = config.params[propName];
                const part = encodeURIComponent(propName) + "=";
                if (value !== null && typeof (value) !== "undefined") {
                    if (typeof value === 'object') {
                        for (const key of Object.keys(value)) {
                            let params = propName + '[' + key + ']';
                            const subPart = encodeURIComponent(params) + "=";
                            url += subPart + encodeURIComponent(value[key]) + "&";
                        }
                    } else {
                        url += part + encodeURIComponent(value) + "&";
                    }
                }
            }
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// 响应拦截器
_axios.interceptors.response.use(
    function (res) {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401) {
            MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                store.dispatch('LogOut').then(() => {
                    location.href = '/login';
                })
            })
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: '系统错误！',
                message: msg
            })
            return Promise.reject(new Error(msg))
        } else {
            return res.data
        }
    },
    function (error) {
        let {message} = error;
        if (message === "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error);
    }
);
export default _axios;
